import React, { Component } from 'react';
import {
	IImpersonationProps,
	IImpersonationState,
} from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import { Search } from '@kurtosys/ksys-app-components/dist/components/base/Search/Search';
import Wrapper from './styledComponents/Wrapper';
import { List } from '@kurtosys/ksys-app-components/dist/components/base/List/List';
import { computed } from 'mobx';
import ImpersonateUserRow from './styledComponents/ImpersonateUserRow';
import ImpersonateUserRowLabel from './styledComponents/ImpersonateUserRowLabel';
import ImpersonateUserRowButton from './styledComponents/ImpersonateUserRowButton';
import ImpersonateSearchHeadingLabel from './styledComponents/ImpersonateSearchHeadingLabel';
import ResultsPane from './styledComponents/ResultsPane';
import Paging from '@kurtosys/ksys-app-components/dist/components/base/Paging';
import { ActionTiles } from '../App/models/ActionTiles';
import ErrorMessage from '../App/styledComponents/ErrorMessage';
import SuccessMessage from '../App/styledComponents/SuccessMessage';
import { ImpersonationStore } from './stores/ImpersonationStore';
import StopImpersonatingButton from './styledComponents/StopImpersonatingButton';

@inject('appStore', 'messageStore', 'impersonationStore')
@observer
export class Impersonation extends Component<IImpersonationProps, IImpersonationState> {
	static configurationKey: 'impersonation' = 'impersonation';
	static styleKey: 'impersonation' = 'impersonation';
	constructor(props: IImpersonationProps) {
		super(props);
	}

	userButtonItem(username: string) {
		const { impersonationStore } = this.props;
		if (!impersonationStore) {
			return undefined;
		}
		const row = (
			<ImpersonateUserRow
				onClick={ async () => {
					await impersonationStore.onClickUser(username);
				} }>
				<ImpersonateUserRowLabel data-qa-ref="impersonateUserLabel" value={ username } key={ username } />
				<ImpersonateUserRowButton data-qa-ref="impersonateUserButton">{ impersonationStore.impersonateUserButtonText }</ImpersonateUserRowButton>
			</ImpersonateUserRow >);
		return row;
	}

	@computed
	get userButtonedList() {
		const { impersonationStore } = this.props;
		if (!impersonationStore) {
			return undefined;
		}
		if (!impersonationStore.userList) {
			return undefined;
		}

		const userButtonedList = impersonationStore.userList.map(user => this.userButtonItem(user.userName));
		return userButtonedList;
	}

	render() {
		const { className, impersonationStore, appStore, messageStore } = this.props;

		if (!impersonationStore || !appStore || !messageStore) {
			return null;
		}

		if (!appStore.isActionEnabled(ActionTiles.USER_IMPERSONATION)) {
			return null;
		}

		const { errorTexts, infoTexts } = messageStore;
		const { componentKey } = ImpersonationStore;
		const { impersonationCardProps } = appStore;
		const { searchProps, pagingProps, impersonationSearchHeading, impersonationListHeading, impersonationActive, hideActiveImpersonation, stopImpersonatingButtonText, stopImpersonating } = impersonationStore;

		if (impersonationActive) {
			if (hideActiveImpersonation) {
				return null;
			}
			return (
				<Wrapper className={ className } { ...impersonationCardProps }>
					<StopImpersonatingButton onClick={ stopImpersonating }>
						{ stopImpersonatingButtonText }
					</StopImpersonatingButton>
				</Wrapper>
			);
		}

		return (
			<Wrapper className={ className } { ...impersonationCardProps }>
				<ImpersonateSearchHeadingLabel value={ impersonationSearchHeading } />
				<Search { ...searchProps }></Search>
				<ResultsPane>
					<List
						heading={ impersonationListHeading }
						items={
							this.userButtonedList
						}
					/>
					<Paging { ...pagingProps } />
				</ResultsPane>
				<ErrorMessage data-qa-ref="impersonationError" >
					{ errorTexts.get(componentKey) }
				</ErrorMessage>
				<SuccessMessage data-qa-ref="impersonationInfo">
					{ infoTexts.get(componentKey) }
				</SuccessMessage>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(Impersonation, 'impersonation');

